import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-rate/es/index.js
// module id = 671
// module chunks = 0 1